import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 30px;
	right: 30px;
	display: flex;
	column-gap: 40px;
	align-items: center;
	user-select: none;
	pointer-events: none;
`;

const StyledStatsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledStatContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledXPContainer = styled.div`
	display: flex;
	column-gap: 20px;
	align-items: center;
`;

const StyledMoneyDeposit = styled(Text)<{ $negative?: boolean }>`
	position: absolute;
	right: 0;
	text-shadow: 1px 1px 0px #000000;
	color: ${(props) => (props.$negative ? '#FF3737' : '#77de38')};
	font-size: 18px;
	font-weight: 500;
	white-space: nowrap;
	transform: translateY(23px);
	opacity: 0;

	transition:
		transform 0.75s ease,
		opacity 0.75s ease;

	&.fade-enter {
		transform: translateY(23px);
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		transform: translateY(33px);
		opacity: 1;
	}

	&.fade-exit-active {
		transform: translateY(23px);
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledMoneyDeposit,
	StyledStatContainer,
	StyledStatsContainer,
	StyledXPContainer,
};
